import React, { Fragment } from "react";

import {
  createTheme,
  makeStyles,
  ThemeProvider,
  useTheme,
} from "@material-ui/core/styles";

import { AppBar } from "react-admin";

import Announcements from "../../components/common/Announcements";

const useStyles = makeStyles((theme) => ({
  spacer: {
    flex: 1,
  },
  logo: {
    margin: "auto",
  },
}));

export const CrewAppBar = (props, userMenu) => {
  const classes = useStyles();
  const svgLogo = "/logo_transloads_white.svg";

  // 1. Grab the Admin-provided theme (light or dark)
  const baseTheme = useTheme();

  // 2. Merge in only our AppBar override, preserving all of baseTheme
  const mergedTheme = createTheme({
    ...baseTheme,
    overrides: {
      ...baseTheme.overrides,
      RaAppBar: {
        toolbar: {
          // hide all but the first button
          "& button:not(:first-child)": {
            display: "none",
          },
        },
      },
    },
  });

  return (
    <ThemeProvider theme={mergedTheme}>
      <AppBar
        {...props}
        color="primary"
        userMenu={userMenu}
        container={Fragment}
      >
        <span className={classes.spacer} />
        <div className={classes.logo}>
          <img src={svgLogo} alt="transloads.co logo" height="30px" />
        </div>
        <span className={classes.spacer} />
      </AppBar>
      <Announcements />
    </ThemeProvider>
  );
};
